export enum AxisTextPosition {
    out,
    in,
    none
}